import { Offcanvas } from "react-bootstrap";
import { IModal } from "../stores";
import { useAuth } from "../contexts/auth-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faPowerOff,
  faPlusSquare,
  faGear,
  faMotorcycle,
  faUsersCog,
  faShoppingBag,
  faUserCircle,
  faTriangleExclamation,
  faLayerGroup,
  faPercentage,
  faMoneyBillTrendUp,
  faUtensils,
  faBowlFood,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";

const Sidebar = ({ show, setShowModal }: IModal) => {
  const { isShopAdmin, isShopUser, userName, firstName, surname, clearAuth } =
    useAuth();

  return (
    <Offcanvas
      show={show}
      onHide={() => setShowModal(false)}
      placement="start"
      className="d-flex flex-column flex-shrink-0 p-3"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <FontAwesomeIcon icon={faUserCircle} className="me-2 text-primary" />
          {firstName && surname ? `${firstName} ${surname}` : userName}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="m-0" />
      <Offcanvas.Body>
        <div>
          <ul className="nav nav-pills flex-column mb-auto">
            {isShopAdmin || isShopUser ? (
              <>
                <li className="nav-item">
                  <a href="/orders" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faShoppingBag}
                      className="me-4 text-primary fs-5"
                    />
                    Orders
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/tbl-orders" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faUtensils}
                      className="me-4 text-dark fs-5"
                    />
                    Dine-In Order
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-products"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faBowlFood}
                      className="me-4 text-success fs-5"
                    />
                    Products
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/manage-cats" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faLayerGroup}
                      className="me-4 text-primary fs-5"
                    />
                    Product Categories
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-addons"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      className="me-4 text-info fs-5"
                    />
                    Add-Ons
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-allergens"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faTriangleExclamation}
                      className="me-4 text-warning fs-5"
                    />
                    Allergens
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-offers"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faPercentage}
                      className="me-4 text-success fs-5"
                    />
                    Product Offers
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-vouchers"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faMoneyBill}
                      className="me-4 text-success fs-5"
                    />
                    Vouchers
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/manage-drivers"
                    className="nav-link link-dark d-flex"
                  >
                    <FontAwesomeIcon
                      icon={faMotorcycle}
                      className="me-4 text-warning fs-5"
                    />
                    Delivery Drivers
                  </a>
                </li>
                {isShopAdmin && (
                  <>
                    <li className="nav-item">
                      <a
                        href="/shop-settings"
                        className="nav-link link-dark d-flex"
                      >
                        <FontAwesomeIcon
                          icon={faGear}
                          className="me-4 text-default fs-5"
                        />
                        Shop Settings
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/manage-fin"
                        className="nav-link link-dark d-flex"
                      >
                        <FontAwesomeIcon
                          icon={faMoneyBillTrendUp}
                          className="me-4 text-primary fs-5"
                        />
                        Finance
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/manage-users"
                        className="nav-link link-dark d-flex"
                      >
                        <FontAwesomeIcon
                          icon={faUsersCog}
                          className="me-4 text-success fs-5"
                        />
                        Users
                      </a>
                    </li>
                  </>
                )}
                <li>
                  <hr />
                </li>
                <li className="nav-item">
                  <a href="/account" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="me-3 text-primary fs-5"
                    />
                    My Account
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#"
                    onClick={() => clearAuth()}
                    className="nav-link link-dark"
                  >
                    <FontAwesomeIcon
                      icon={faPowerOff}
                      className="me-3 text-danger fs-5"
                    />
                    Logout
                  </a>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <a href="/account" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="me-3 text-primary fs-5"
                    />
                    My Account
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/my-orders" className="nav-link link-dark d-flex">
                    <FontAwesomeIcon
                      icon={faShoppingBag}
                      className="me-3 text-success fs-5"
                    />
                    My Orders
                  </a>
                </li>
                <li>
                  <hr />
                </li>
                <li className="nav-item">
                  <a
                    href="#"
                    onClick={() => clearAuth()}
                    className="nav-link link-dark"
                  >
                    <FontAwesomeIcon
                      icon={faPowerOff}
                      className="me-3 text-danger fs-5"
                    />
                    Logout
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Sidebar;
